export default {
  path: '/main/wechatMgmt/dingGroupConfig',
  name: 'DingGroupConfig',
  component: () =>
    import('@/views/main/wechatMgmt/dingGroupConfig/DingGroupConfig.vue')
}
